<service-settings-configuration
  *ngIf="service"
  [service]="service"
  [guideTypesOptions]="guideTypesOptions"
  [guideTypesEnum]="guideTypesEnum"
  (saveEmitter)="saveService()">
</service-settings-configuration>
